export const isValidCPMValues = (
  dealCPM: number | string | undefined,
  lineMinCPM: number | string | undefined,
  lineMaxCPM: number | string | undefined,
): boolean => {
  if (!dealCPM && !lineMinCPM && !lineMaxCPM) {
    return true;
  }

  if (lineMaxCPM && dealCPM && lineMaxCPM > dealCPM) {
    return false;
  }

  if (lineMinCPM && dealCPM && lineMinCPM > dealCPM) {
    return false;
  }

  if (lineMinCPM && lineMaxCPM && lineMinCPM > lineMaxCPM) {
    return false;
  }

  return true;
};
